export const P00062ModeFonctionnementTemperature = [
  { ref: 0, label: 'P00062.params.modeFonctionnementTemperature.froid' },
  { ref: 1, label: 'P00062.params.modeFonctionnementTemperature.chaud' },
  { ref: 2, label: 'P00062.params.modeFonctionnementTemperature.auto' },
];
